import React, { useContext, useState } from 'react'
import ApplicationContext from '../../context/ApplicationContext'
import styles from './Footer.module.scss'
import FittersLegend from './FittersLegend/FittersLegend'
import { ReactComponent as ArrowRight } from '../../assets/media/icons/icon-arrow-right.svg'
import '../../index.scss'

const Footer = () => {
    const [applicationData] = useContext(ApplicationContext)
    const [localizations] = useState(applicationData.localizations)
    const { left } = localizations.footer

    return (
        <div className={styles.footerContainer}>
            <div className={styles.paintLeftSide}></div>
            <div className={styles.footerContainer_leftBoxWrapper}>
                <div className={styles.footerContainer_leftBox}>
                    {left.map((item, index) => {
                        return (
                            <div key={index}>
                                {item.type === 'text' && (
                                    <>
                                        {item.title && <p className={styles.paragraphHeading}>{item.title}</p>}
                                        {item.description && <p>{item.description}</p>}
                                    </>
                                )}
                                {item.type === 'link' && applicationData[item.key] !== 'hide' && (
                                    <a
                                        href={applicationData[item.key] !== '' ? applicationData[item.key] : item.href}
                                        className={styles.link}
                                        target={`${item.target ?? '_blank'}`}
                                        rel='noreferrer nofollow'
                                    >
                                        {item.text}
                                        <ArrowRight />
                                    </a>
                                )}
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className={styles.footerContainer_rightBoxWrapper}>
                <FittersLegend />
            </div>
        </div>
    )
}

export default Footer
